import React, { useState } from "react";
import { motion } from "framer-motion";
import Map from '../components/Map';
import "../styles/Contact.css";
import emailjs from '@emailjs/browser';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      alert("Inquiry sent successfully!");
      setFormData({ firstName: "", lastName: "", email: "", subject: "", message: "" });
    } catch (error) {
      console.error("Failed to send:", error);
      alert("Failed to send inquiry. Please try again.");
    }
  };

  const offices = [
    {
      title: "Head Office - Pakistan",
      address: "20 Km Ferozepur Road, Youhanabad Lahore, Pakistan",
      email: "info@softwoodtextiles.com",
      phone: "+92-4235951191/92"
    },
    {
      title: "France Office",
      address: "20 Rue Sandro Botticelli 68260, Kingersheim, France",
      email: "arman@softwoodtextiles.com",
      phone: "+33-610691868"
    }
  ];

  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
  };

  return (
    <div className="contact-modern-page">

      {/* ── Ultra-Premium Image Hero ── */}
      <section
        className="premium-contact-hero"
        style={{ backgroundImage: `url('/img/contact/11062b_81792b1e3d5041e7b9996443920904a4~mv2.png')` }}
      >
        <div className="hero-gradient-overlay"></div>
        <div className="container">
          <motion.div className="hero-content-grid" initial="hidden" animate="visible" variants={fadeUp}>
            <div className="hero-eyebrow-col">
              <span className="copper-eyebrow">Partner of Choice</span>
              <div className="vertical-accent"></div>
            </div>
            <div className="hero-title-col">
              <h1 className="massive-contact-title">
                Start the <br />
                <span className="hero-italic">Conversation.</span>
              </h1>
              <p className="hero-subtext">
                A production program, a sourcing inquiry, or a fabric brief — tell us what you are planning and it will reach the right team, whether that is merchandising in Lahore or our office in France. You will get a direct assessment of whether we are the right partner for the program.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ── Split Layout: Info & Minimalist Form ── */}
      <section className="contact-split-section">
        <div className="container contact-grid">

          {/* Left Column: Office Locations */}
          <motion.div
            className="contact-info-col"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeUp}
          >
            <h2>Global Presence.</h2>
            <div className="copper-divider"></div>

            <div className="offices-container">
              {offices.map((office, index) => (
                <div className="office-card" key={index}>
                  <h3>{office.title}</h3>
                  <div className="office-detail">
                    <span className="detail-label">Address</span>
                    <p>{office.address}</p>
                  </div>
                  <div className="office-detail">
                    <span className="detail-label">Email</span>
                    <a href={`mailto:${office.email}`}>{office.email}</a>
                  </div>
                  <div className="office-detail">
                    <span className="detail-label">Phone</span>
                    <a href={`tel:${office.phone}`}>{office.phone}</a>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>

          {/* Right Column: Premium Document Form */}
          <motion.div
            className="contact-form-col"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeUp}
          >
            <div className="form-wrapper">
              <h2>Direct Inquiry</h2>
              <form onSubmit={handleSubmit} className="premium-form">

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="firstName">First Name</label>
                    <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleChange} required />
                  </div>
                  <div className="form-group">
                    <label htmlFor="lastName">Last Name</label>
                    <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleChange} required />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="email">Corporate Email</label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject</label>
                  <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} required />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message Details</label>
                  <textarea id="message" name="message" rows="3" value={formData.message} onChange={handleChange} required></textarea>
                </div>

                <button type="submit" className="premium-submit-btn">
                  Submit Inquiry &rarr;
                </button>
              </form>
            </div>
          </motion.div>

        </div>
      </section>

      {/* ── Seamless Map Integration ── */}
      <section className="contact-map-section">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <Map />
        </motion.div>
      </section>

    </div>
  );
};

export default ContactPage;